export default {
  nome: {
    value: null,
    maxlength: '200',
    required: true,
    state: null
  },
  gedTipoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  gedAssuntoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  gedTagID: {
    value: null,
    options: []
  },
  gedArquivoTags: {
    value: [],
    required: false,
    state: null
  },
  observacao: {
    value: null,
    required: false,
    state: null
  },
  validade: {
    value: null,
    required: false,
    state: null
  },
  inicio: {
    value: null,
    required: false,
    state: null
  },
  diasAlerta: {
    value: null,
    required: false,
    state: null
  },
  emailsAlerta: {
    value: null,
    required: false,
    state: null
  },
  tamanho: {
    value: 0
  },
  versao: {
    value: 0
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/content/doccontent-form.js